module.exports = __webpack_public_path__ + "static/media/snapshot_onboarding_ios_2.0c5e4d5a.png";